<div class="sitemap-container">
  <div class="content">
    <ng-container
      *ngTemplateOutlet="sitemapItem; context: { item: sitemap, level: 0 }"
    ></ng-container>
  </div>
</div>

<ng-template #sitemapItem let-items="item" let-level="level">
  <ul [style.padding-left]="level * 16 + 'px'">
    @for (item of items; track item.url) {
      <li>
        <a [uiSref]="item.url">{{ item.name }}</a>
        @if (item.children) {
          <ng-container
            *ngTemplateOutlet="
              sitemapItem;
              context: { item: item.children, level: level + 1 }
            "
          ></ng-container>
        }
      </li>
    }
  </ul>
</ng-template>
